export const ACCESS_TOKEN = 'access-token';
export const USER_DETAILS = 'user-details';
export const CREDITS_INFO = 'credits-info';
export const SEARCH_ROUTE_ONCE_LOADED = 'search-route-once-loaded';
